import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      accessToken: null,

      login: (userData, accessToken = null) => {
        set({
          user: userData,
          isAuthenticated: !!userData,
          accessToken,
        });
      },

      setUser: (userData) => {
        set({
          user: userData,
          isAuthenticated: !!userData,
        });
      },

      setAccessToken: (accessToken) => {
        set({
          accessToken,
          isAuthenticated: !!accessToken,
        });
      },

      logout: () => {
        set({
          user: null,
          isAuthenticated: false,
          accessToken: null,
        });
      },

      updateUser: (userData) => {
        set((state) => ({
          user: { ...state.user, ...userData },
        }));
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);

export default useAuthStore;
